// src/ui/inventory/src/auth/index.js
import { useMSAuth } from './msAuth'
import { useLocalAuth } from './localAuth'

const authMethod = import.meta.env.VITE_APP_AUTH_METHOD || 'msal'

let useAuth
if (authMethod === 'local') {
  console.debug('Using local authentication.')
  useAuth = useLocalAuth
} else {
  console.debug('Using MSAL authentication.')
  useAuth = useMSAuth
}

export { useAuth, authMethod }
